// @flow
/** @jsx h */
import { h } from 'preact';
import style from './style.css';

type Props = {
  name: string,
  desktopImgUrl: string,
  brandClick: Function,
};

const Brand = ({ name, desktopImgUrl, brandClick }: Props) => {
  return (
    <div
      onClick={brandClick}
      className={style.image}
      style={{
        backgroundImage: `url(${desktopImgUrl})`,
      }}
    />
  );
};

export default Brand;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/brand/index.js